import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { UserState, LayoutProps, SpendingReportState } from '../interface/MyInterfaces';
import { EmployeeReportState } from '../interface/EmployeeReportInterface';
import { VendorReportState } from '../interface/VendorReportInterface';
import { VendorReportState2025 } from '../interface/VendorReportInterface2025';
import { CTSAReportState } from '../interface/CTSAReportInterface';
import NewSpendingReportButton from './NewSpendingReportButton';
import { downloadPDFReport, downloadReport } from '../actions/SpendingReportActions';
import { downloadNewVendorReportData } from '../actions/VendorReportActions';
import { downloadNewVendorReportData2025 } from '../actions/VendorReportActions2025';
import { downloadCTSAData } from '../actions/CTSAReportActions';
import { clearSharedLink } from '../actions/UserActions';

import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';
import { bindActionCreators } from 'redux';

import SharedLinkForm from './Reports/SharedLinkForm';
import styled from "styled-components";

import html2canvas from "html2canvas";

import { saveAs } from 'file-saver';
import { isAgg, getVintageFromReportType } from './common/Helpers';
interface ReportLayoutProps {
    UserState?: UserState;
    SpendingReportState?: SpendingReportState;
    CTSAReportState?:CTSAReportState;
    EmployeeReportState?: EmployeeReportState;
    VendorReportState?: VendorReportState;
    VendorReportState2025?: VendorReportState2025;
    //downloadReport(SpendingReportState, FilterState);
    downloadReport?:any;
    //downloadCTSAData(CTSAReportState);
    downloadCTSAData?:any;
    downloadNewVendorReportData?: any;
    downloadNewVendorReportData2025?: any;
    downloadPDFReport?(activeTabIndex, reportType);
    clearSharedLink?();
}

interface ReportLayoutState {
    currentDateTime?: any;
    showModal?: any;
    activeTabIndex: number;
    downloadWasCalled?: boolean;
    tabsPrinted?: number;
    spendingDataAllLoaded?: boolean;
}

const DownloadButton = styled.button`
    color:#fff;
    cursor:pointer;
    font-size:18px;
    background-color: transparent;
    border: none;
    &:disabled{
        color: #d9d9d9;
    }
`;

class ReportLayout extends React.Component<ReportLayoutProps & LayoutProps & RouteComponentProps<{}>, ReportLayoutState> {
    constructor(props) {
        super(props);
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
        this.state = { showModal: false, activeTabIndex: 0, currentDateTime: currentDate, downloadWasCalled: false, tabsPrinted: 0, spendingDataAllLoaded: false };
        this.handleOpenSharedLink = this.handleOpenSharedLink.bind(this);
        this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
        this.closeShareWindow = this.closeShareWindow.bind(this);
        this.handleDownloadPDF = this.handleDownloadPDF.bind(this);
        this.saveImage = this.saveImage.bind(this);
        this.savePDF = this.savePDF.bind(this);
    }

    //reportType(controller) {
    //    var reportType = "spending_report";
    //    if (controller == "Report")
    //        reportType = "spending_report";

    //    return reportType;
    //}

    async saveImage(div, index, fileName, controller) {
        var element = document.getElementsByClassName(div)[index];
        var currentDateTime = this.state.currentDateTime;
        var userState = this.props.UserState;
        var report_type = this.props.match.path.split('/')[2];
        await html2canvas(element as HTMLCanvasElement).then(function (canvas) {
            canvas.toBlob(function (blob) {
                let url = "/webapi/" + controller + "/send_image/";
                let form = new FormData();
                form.append('image', blob, fileName);
                form.append("display_id", userState.report_display_id);
                form.append("currentDateTime", currentDateTime);
                form.append("vintage", getVintageFromReportType(report_type, userState));

                fetch(url, { method: 'POST', body: form })
            });
        });
        
    }

    componentDidUpdate(prevProps) {
        //console.log(this.props.SpendingReportState);
		const spendingDataAllLoaded = (isAgg(this.props.UserState.report_display_id) && this.props.SpendingReportState.SpendingEmployeeChart_Data !== undefined
            && this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data !== undefined 
            && this.props.SpendingReportState.SpendingExpenditureMap !== undefined
            && this.props.SpendingReportState.SpendingCongressMap !== undefined)//if aggregate no benchmarking tab
            || (this.props.SpendingReportState.SpendingEmployeeChart_Data !== undefined
            && this.props.SpendingReportState.SpendingEmployeeAgencyChart_Data !== undefined
            && this.props.SpendingReportState.SpendingExpenditureMap !== undefined
            && this.props.SpendingReportState.SpendingCongressMap !== undefined
            && this.props.SpendingReportState.SpendingSummaryTable !== undefined
            && this.props.SpendingReportState.SpendingEmployeeTable !== undefined
            && this.props.SpendingReportState.SpendingEmployeeAgencyTable !== undefined
            && this.props.SpendingReportState.SpendingExpenditureTable !== undefined
            && this.props.SpendingReportState.SpendingExpenditureTable2 !== undefined
                && this.props.SpendingReportState.SpendingInStateExpenditureBoxPlot !== undefined) ||

            ((this.props.UserState.report_display_id == 14105 || 
                this.props.UserState.report_display_id == 14977 || 
                this.props.UserState.report_display_id == 20802 || 
                this.props.UserState.report_display_id == 42640 ||
                this.props.UserState.report_display_id == 81130)
                && this.props.SpendingReportState.SpendingExpenditureMap !== undefined
                && this.props.SpendingReportState.SpendingCongressMap !== undefined
                && this.props.SpendingReportState.SpendingSummaryTable !== undefined
                && this.props.SpendingReportState.SpendingExpenditureTable !== undefined
                && this.props.SpendingReportState.SpendingExpenditureTable2 !== undefined
                && this.props.SpendingReportState.SpendingInStateExpenditureBoxPlot !== undefined);
        if (this.props.SpendingReportState != prevProps.SpendingReportState) {
            this.setState({ spendingDataAllLoaded });
        }
    }

    closeShareWindow() {
        this.setState({
            showModal: false
        });

    }

    handleOpenSharedLink() {
        this.setState({
            showModal: true
        });
        this.props.clearSharedLink();
    }

    handleDownloadFiles() {
        var report_type = this.props.match.path.split('/')[2];
        if (report_type === "spending_report") {
            this.props.downloadReport(this.props.SpendingReportState, this.props.FilterState);
        } else if (report_type === "new-vendor-report") {
            this.props.downloadNewVendorReportData(this.props.VendorReportState,this.props.UserState);
        } else if (report_type === "new-vendor-report2025") {
            this.props.downloadNewVendorReportData2025(this.props.VendorReportState2025, this.props.UserState);
        }else {
            this.props.downloadCTSAData(this.props.CTSAReportState);

        }
    }



    savePDF(controller) {
        var currentDateTime = this.state.currentDateTime;
        var display_id = this.props.UserState.report_display_id;
        var university = this.props.UserState.university;
        let url = "/webapi/" + controller + "/generate_pdf/";
        const isStateAgg = this.props.SpendingReportState.SpendingReportConf ? this.props.SpendingReportState.SpendingReportConf.state_fips : 0;
        const employeeChart = this.props.SpendingReportState.SpendingEmployeeChart;
        const employeeAgencyChart = this.props.SpendingReportState.SpendingEmployeeAgencyChart;
        var obj = {};//this.props.SpendingReportState.SpendingReport_Tab1;

        obj["display_id"] = display_id;
        obj["currentDateTime"] = currentDateTime;
        obj["university"] = university;

        var report_type = this.props.match.path.split('/')[2];
        obj["vintage"] = getVintageFromReportType(report_type, this.props.UserState);

        if (report_type == "spending_report") {
            obj["SpendingReport_Tab1"] = this.props.SpendingReportState.SpendingReport_Tab1;
            obj["SpendingReport_Tab2"] = this.props.SpendingReportState.SpendingReport_Tab2;
            obj["SpendingReport_Tab3"] = this.props.SpendingReportState.SpendingReport_Tab3;
            obj["SpendingReport_Tab4"] = this.props.SpendingReportState.SpendingReport_Tab4;
            obj["isStateAgg"] = isStateAgg;
            obj["Benchmarking_Table1"] = employeeChart;
            obj["Benchmarking_Table2"] = employeeAgencyChart;
        }
        else if (report_type == "employee_report") {
            obj["EmployeeReport_Tab1"] = this.props.EmployeeReportState.EmployeeReport_Tab1;
            obj["EmployeeReport_Tab2"] = this.props.EmployeeReportState.EmployeeReport_Tab2;
            obj["EmployeeReport_MatchRateTab"] = this.props.EmployeeReportState.EmployeeReport_MatchRateTab;
            obj['university'] = this.props.EmployeeReportState.EmployeeProfileInfo.university;
            obj['drbApprovalNumber'] = this.props.EmployeeReportState.EmployeeProfileInfo.drB_approval_number;
            obj['inflation_year'] = this.props.EmployeeReportState.EmployeeProfileInfo.inflation_year;
            obj["isAgg"] = isAgg(display_id);
        }
        else if (report_type == "new-vendor-report") {
            if (this.props.VendorReportState.ReportsConf != undefined)
                obj["MethodologyText"] = this.props.VendorReportState.ReportsConf.methodology_text;
            obj["Tab1"] = this.props.VendorReportState.VendorReport_Tab1;
            obj["Tab2"] = this.props.VendorReportState.VendorReport_Tab2;
            obj["Tab3"] = this.props.VendorReportState.VendorReport_Tab3;
            obj["Tab4"] = this.props.VendorReportState.VendorReport_Tab4;
            obj["vendorRelease"] = this.props.VendorReportState.vendorRelease
            if (this.props.VendorReportState.HomeState != undefined) {
                obj["university"] = this.props.VendorReportState.HomeState.campusname;
                obj["title"] = this.props.VendorReportState.HomeState && this.props.VendorReportState.HomeState.title;
            }
            obj["MatchRateTab"] = this.props.VendorReportState.VendorReport_MatchRateTab;
        }
        else if (report_type == "new-vendor-report2025") {
            if (this.props.VendorReportState2025.ReportsConf != undefined)
                obj["MethodologyText"] = this.props.VendorReportState2025.ReportsConf.methodology_text;
            obj["Tab1"] = this.props.VendorReportState2025.VendorReport_Tab12025;
            obj["Tab2"] = this.props.VendorReportState2025.VendorReport_Tab2;
            obj["Tab3"] = this.props.VendorReportState2025.VendorReport_Tab3;
            obj["Tab4"] = this.props.VendorReportState2025.VendorReport_Tab4;
            obj["vendorRelease"] = this.props.VendorReportState2025.vendorRelease
            if (this.props.VendorReportState2025.HomeState != undefined) {
                obj["university"] = this.props.VendorReportState2025.HomeState.campusname;
                obj["title"] = this.props.VendorReportState2025.HomeState && this.props.VendorReportState2025.HomeState.title;
            }
            obj["MatchRateTab"] = this.props.VendorReportState2025.VendorReport_MatchRateTab;
        }
        if (obj["display_id"] != null) {
            var headers = new Headers();
            headers.append('Accept', 'application/json'); // This one is enough for GET requests
            headers.append('Content-Type', 'application/json'); // This one sends body
            fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
                .then(res => {
                    return res.blob();
                })
                .then(blob => {
                    if (report_type == "spending_report") {
                        saveAs(blob, 'SpendingReport_' + currentDateTime + '.pdf');
                    } else if (report_type == "employee_report") {
                        saveAs(blob, 'EmployeeReport_' + currentDateTime + '.pdf');
                    }
                    else if (report_type.startsWith("new-vendor-report")) {
                        saveAs(blob, 'VendorReport_' + currentDateTime + '.pdf');
                    }
                }).catch((error) => {
                    console.log(error);
                })
        }
        this.setState({ downloadWasCalled: false });

    }
    
    handleDownloadPDF = (activeTabIndex, report_type) => e => {
        if (this.props.UserState.report_display_id == 999788 && report_type.startsWith("new-vendor-report")) {
            this.specialSave(report_type);
        }
        else {
            if (report_type == "spending_report") {

                this.setState({
                    tabsPrinted: 1,
                    downloadWasCalled: true
                });
                const agg = isAgg(this.props.UserState.report_display_id);
                const total = agg ? 3 : 4; //aggregate report no benchmarking tab
                const isStateAgg = this.props.SpendingReportState.SpendingReportConf ? this.props.SpendingReportState.SpendingReportConf.state_fips : 0;
                const employeeChart = this.props.SpendingReportState.SpendingEmployeeChart;
                const employeeAgencyChart = this.props.SpendingReportState.SpendingEmployeeAgencyChart;
                if (this.state.spendingDataAllLoaded) {
                    if (activeTabIndex == 0) {
                        this.saveFirstTab("Report", agg, isStateAgg, total, employeeChart, employeeAgencyChart);
                    }
                    else if (activeTabIndex == 1) {
                        this.saveCongressMaps("Report", agg, isStateAgg, total);
                    }
                    else if (activeTabIndex == 2) {
                        this.saveBenchmarking("Report", agg, isStateAgg, total, employeeChart, employeeAgencyChart);
                    }
                    else if (activeTabIndex == 4) {
                        this.saveMethodology("Report", agg, isStateAgg, total);
                    }
                }

            } else if (report_type == "employee_report") {
                const agg = isAgg(this.props.UserState.report_display_id);
                const totalTabs = agg ? 3 : 4; //agg employee report has no match rate tab
                this.setState({
                    tabsPrinted: 1,
                    downloadWasCalled: true
                });

                if (this.props.EmployeeReportState !== undefined
                    && this.props.EmployeeReportState.EmployeeReport_Tab1 !== undefined
                    && this.props.EmployeeReportState.EmployeeReport_Tab2 !== undefined
                    && (agg || this.props.EmployeeReportState.EmployeeReport_MatchRateTab !== undefined)) {
                    if (activeTabIndex == 0) {
                        this.saveGeographicDestinationsTab("EmployeeReport", totalTabs);
                    }
                    else if (activeTabIndex == 1) {
                        this.saveSectorsAndEarningsTab("EmployeeReport", agg, totalTabs);
                    }
                    else if (activeTabIndex == 2) {
                        this.saveEmployeeMethodology("EmployeeReport", agg, totalTabs);
                    }
                    else if (activeTabIndex == 3) {
                        this.saveEmployeeMatchRate("EmployeeReport", totalTabs);
                    }
                }

            } else if (report_type == "new-vendor-report") {
                this.setState({
                    tabsPrinted: 1,
                    downloadWasCalled: true
                })

                if (this.props.VendorReportState !== undefined
                    && this.props.VendorReportState.VendorReport_Tab1 !== undefined
                    && this.props.VendorReportState.VendorReport_Tab3 !== undefined
                    && this.props.VendorReportState.VendorReport_Tab4 !== undefined
                    //&& this.props.VendorReportState.VendorReport_MatchRateTab !== undefined
                ) {
                    if (activeTabIndex == 0) {
                        this.saveVendorProfilesTab("NewVendorReport");
                    }
                    else if (activeTabIndex == 1) {
                        this.saveIndustryRevenueTab("NewVendorReport");
                    }
                    else if (activeTabIndex == 2) {
                        this.saveNewVendorMethodologyTab("NewVendorReport");
                    }
                }

            }
            else if (report_type == "new-vendor-report2025") {
                this.setState({
                    tabsPrinted: 1,
                    downloadWasCalled: true
                })

                if (this.props.VendorReportState2025 !== undefined
                    && this.props.VendorReportState2025.VendorReport_Tab12025 !== undefined
                    && this.props.VendorReportState2025.VendorReport_Tab3 !== undefined
                    && this.props.VendorReportState2025.VendorReport_Tab4 !== undefined
                    //&& this.props.VendorReportState.VendorReport_MatchRateTab !== undefined
                ) {
                    if (activeTabIndex == 0) {
                        this.saveVendorProfilesTab2025("NewVendorReport2025");
                    }
                    else if (activeTabIndex == 1) {
                        this.saveIndustryRevenueTab2025("NewVendorReport2025");
                    }
                    else if (activeTabIndex == 2) {
                        this.saveNewVendorMethodologyTab2025("NewVendorReport2025");
                    }
                }

            }
            else {
                this.props.downloadPDFReport(activeTabIndex, report_type);
            }
        }
    }

    async saveGeographicDestinationsTab(controller,total) {
        await this.saveImage("chartcontainer", 0, "chart1.png", controller);

        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab2")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    expectedTabs = () => {
        return 3;
    }

    async saveVendorProfilesTab2025(controller) {
        await this.saveImage("national", 0, "national.png", controller);
        await this.saveImage("instate", 0, "instate.png", controller);
        await this.saveImage("smallbusiness", 0, "smallbusiness.png", controller);
        await this.saveImage("benchmarking", 0, "benchmarking.png", controller);

        if (this.state.tabsPrinted < this.expectedTabs()) {
            let tab: HTMLElement = document.getElementsByClassName("tab4")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }


    async saveVendorProfilesTab(controller) {
        await this.saveImage("line-chart-legend-container", 0, "LineTrendLegend.png", controller);

        await this.saveImage("LineTrend", 0, "LineTrend1.png", controller);
        await this.saveImage("LineTrend", 1, "LineTrend2.png", controller);

        await this.saveImage("radarStyle", 0, "radarStyle1.png", controller);
        await this.saveImage("radarStyle", 1, "radarStyle2.png", controller);

        await this.saveImage("radar-legend", 0, "radar-legend.png", controller);

        if (this.state.tabsPrinted < this.expectedTabs()) {
            let tab: HTMLElement = document.getElementsByClassName("tab4")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async specialSave(report_type) {
        const controller = report_type.equals("new-vendor-report2025") ? "NewVendorReport" : "NewVendorReport2025"
        
        await this.saveImage("sunburst", 0, "sunburstbvd.png", controller);
        await this.saveImage("sunburst-right", 0, "naicsbvd.png", controller);

        this.savePDF(controller);
    }

    async saveIndustryRevenueTab(controller) {
        console.log('saving images on sunburst tab')
        await this.saveImage("sunburst", 0, "sunburstbvd.png", controller);
        await this.saveImage("sunburst-right", 0, "naicsbvd.png", controller);
        console.log('done saving images on sunburst tab')
        if (this.state.tabsPrinted < this.expectedTabs()) {
            let tab: HTMLElement = document.getElementsByClassName("tab5")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveIndustryRevenueTab2025(controller) {
        await this.saveImage("sunburst", 0, "sunburstbvd.png", controller);
        await this.saveImage("sunburst-right", 0, "naicsbvd.png", controller);

        if (this.state.tabsPrinted < this.expectedTabs()) {
            let tab: HTMLElement = document.getElementsByClassName("tab5")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }


    async saveNewVendorMethodologyTab(controller) {
        if (this.state.tabsPrinted < this.expectedTabs()) {
            setTimeout(function () {
                let tab: HTMLElement = document.getElementsByClassName("tab1")[0] as HTMLElement;
                tab.click();
            }, 1000)

        }
        else {
            this.savePDF(controller);
        }
    } 

    async saveNewVendorMethodologyTab2025(controller) {
        if (this.state.tabsPrinted < this.expectedTabs()) {
            setTimeout(function () {
                let tab: HTMLElement = document.getElementsByClassName("tab1")[0] as HTMLElement;
                tab.click();
            }, 1000)

        }
        else {
            this.savePDF(controller);
        }
    } 

    async saveSectorsAndEarningsTab(controller, agg, total) {
        await this.saveImage("recharts-wrapper", 0, "earnings1.png", controller);
        await this.saveImage("recharts-wrapper", 1, "earnings2.png", controller);
        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab3")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveEmployeeMethodology(controller, agg, total) {
        await this.saveImage("img_cohort", 0, "cohort.png", controller);
        let tab: HTMLElement;
        if (this.state.tabsPrinted < total) {
            if (agg) {
                //aggregate report no match rate tab jump to first tab
                tab = document.getElementsByClassName("tab1")[0] as HTMLElement;
            } else {
                tab = document.getElementsByClassName("tab4")[0] as HTMLElement;
            }
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveEmployeeMatchRate(controller,total) {
        await this.saveImage("employee_match_rate", 0, "employee_match_rate.png", controller);
        //await this.saveImage("med_table", 1, "methodology2.png", controller);
        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab1")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveFirstTab(controller, agg, isStateAgg, total, employeeChart, employeeAgencyChart) {
        var empCharts = document.getElementsByClassName("recharts-wrapper");
        
        if (employeeChart!=null && employeeChart.length>0) {
            await this.saveImage("recharts-wrapper", 0, "chart1.png", controller);
        }
        if (employeeAgencyChart != null && employeeAgencyChart.length > 0 ) {
            await this.saveImage("recharts-wrapper", 1, "chart2.png", controller);
        }
        await this.saveImage("mapcontainer", 0, "chart3.png", controller);
        if (!agg || isStateAgg) {
            //non-aggregate or state level aggregation
            await this.saveImage("mapcontainer", 1, "chart4.png", controller); //non-state level aggregation combined chart4 to chart3
        }
        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab2")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveCongressMaps(controller, agg, isStateAgg, total) {
        await this.saveImage("congress-mapcontainer", 0, "congress_map1.png", controller);
        if (!agg || isStateAgg) {
            //non-aggregate or state level aggregation
            await this.saveImage("congress-mapcontainer", 1, "congress_map2.png", controller); //non-state level aggregation combined chart2 to chart1
        }
        let tab: HTMLElement;
        if (this.state.tabsPrinted < total) {
            if (agg) {
                //aggregate report no benchmarking jump to methodology
                tab = document.getElementsByClassName("tab4")[0] as HTMLElement;
            } else {
                tab = document.getElementsByClassName("tab3")[0] as HTMLElement;
            }
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveBenchmarking(controller, agg, isStateAgg, total, employeeChart, employeeAgencyChart) {
        await this.saveImage("summary_div", 0, "benchmarking1.png", controller);
        var empCharts = document.getElementsByClassName("employeetable");
        if (employeeChart != null && employeeChart.length > 0) {
            await this.saveImage("employeetable", 0, "benchmarking2.png", controller);
        }
        if (employeeAgencyChart != null && employeeAgencyChart.length > 0) {
            await this.saveImage("agencytable", 0, "benchmarking3.png", controller);
        }
        await this.saveImage("expendituretable", 0, "benchmarking4.png", controller);
        await this.saveImage("boxplot", 0, "benchmarking5.png", controller);

        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab4")[0] as HTMLElement;
            tab.click();
        }
        else
            this.savePDF(controller);
    }

    async saveMethodology(controller, agg, isStateAgg, total) {
        //await this.saveImage("med_table", 0, "methodology1.png", controller);
        await this.saveImage("med_table", 0, "methodology2.png", controller);
        if (this.state.tabsPrinted < total) {
            let tab: HTMLElement = document.getElementsByClassName("tab1")[0] as HTMLElement;
            tab.click();
        }
        else 
            this.savePDF(controller);
    }

    handleTabClickFromParent = (activeTabIndex) => {
        //console.log(this.props.SpendingReportState);
        console.log(activeTabIndex);
        this.setState({
            activeTabIndex: activeTabIndex
        });
        console.log(this.state);
        if (this.state.downloadWasCalled) {
            var report_type = this.props.match.path.split('/')[2];
            var that = this;
            console.log(this.state)
            console.log(this.props)
            this.setState({
                tabsPrinted: this.state.tabsPrinted + 1
            });
            const agg = isAgg(this.props.UserState.report_display_id);
            const total = agg ? 3 : 4; //aggregate report no benchmarking tab
            const isStateAgg = this.props.SpendingReportState.SpendingReportConf ? this.props.SpendingReportState.SpendingReportConf.state_fips : 0;
            const employeeChart = this.props.SpendingReportState.SpendingEmployeeChart;
            const employeeAgencyChart = this.props.SpendingReportState.SpendingEmployeeAgencyChart;
            if ((report_type.startsWith("new-vendor-report") && this.state.tabsPrinted == this.expectedTabs()) || (!report_type.startsWith("new-vendor-report") && this.state.tabsPrinted == 4)) {
                console.log('is this being set?')
                console.log(!report_type.startsWith("new-vendor-report") && this.state.tabsPrinted == 4)                
                this.setState({
                    downloadWasCalled: false
                });

            } else {
                if (report_type == "spending_report") {
                    setTimeout(function () {
                        if (activeTabIndex == 0) {
                            that.saveFirstTab("Report", agg, isStateAgg, total, employeeChart, employeeAgencyChart);
                        }
                        else if (activeTabIndex == 1) {
                            that.saveCongressMaps("Report", agg, isStateAgg, total);
                        }
                        else if (activeTabIndex == 2) {
                            that.saveBenchmarking("Report", agg, isStateAgg, total, employeeChart, employeeAgencyChart);
                        }
                        else if (activeTabIndex == 4) {
                            that.saveMethodology("Report", agg, isStateAgg, total);
                        }
                    }, 3000)
                } else if (report_type == "employee_report") {
                    setTimeout(function () {
                        if (activeTabIndex == 0) {
                            that.saveGeographicDestinationsTab("EmployeeReport",total);
                        }
                        else if (activeTabIndex == 1) {
                            that.saveSectorsAndEarningsTab("EmployeeReport", agg, total);
                        }
                            
                        else if (activeTabIndex == 2) {
                            that.saveEmployeeMethodology("EmployeeReport", agg, total);
                        }
                            
                        else if (activeTabIndex == 3) {
                            that.saveEmployeeMatchRate("EmployeeReport",total);
                        }
                    }, 3000)
                } else if (report_type == "new-vendor-report") {
                    setTimeout(function () {
                        if (activeTabIndex == 0) {
                            that.saveVendorProfilesTab("NewVendorReport");
                        }
                        else if (activeTabIndex == 1) {
                            that.saveIndustryRevenueTab("NewVendorReport");
                        }
                        else if (activeTabIndex == 2) {
                            that.saveNewVendorMethodologyTab("NewVendorReport");
                        }

                    }, 3000)
                } else if (report_type == "new-vendor-report2025") {
                    setTimeout(function () {
                        if (activeTabIndex == 0) {
                            that.saveVendorProfilesTab2025("NewVendorReport2025");
                        }
                        else if (activeTabIndex == 1) {
                            that.saveIndustryRevenueTab("NewVendorReport2025");
                        }
                        else if (activeTabIndex == 2) {
                            that.saveNewVendorMethodologyTab("NewVendorReport2025");
                        }

                    }, 3000)
                }


            }
        }

        
    }

    renderChildrenWithProps() {
        return React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child as React.ReactElement<any>, {
                handleTabClickFromParent: this.handleTabClickFromParent,
                //tabIsActive: this.tabIsActive,
                //doneUpdatingTab: this.doneUpdatingTab
            });
        });
    }

    public render() {
        const irislogo = require('../images/IRISLogoW.png');
        const download = require('../images/download.png');
        const share = require('../images/share.png');

        var notShared = true;
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            notShared = false;
        }
        var report_type = this.props.match.path.split('/')[2];
        return <div className="reportLayout" style={{ opacity: sharedLinkPageOnLoad && this.props.UserState.sharedLinkEmailSubmitted===false ? 0 : 1}}>
            <SharedLinkForm reportType={report_type} showModal={this.state.showModal} handleClose={this.closeShareWindow} />
            <header>
                <div className='in_header'>
                    <div className='links'>
                        {notShared &&
                        <span>
                            {report_type == "spending_report" && <NewSpendingReportButton />}
                            {(report_type != "detailed-district-report") && <DownloadButton onClick={this.handleOpenSharedLink} className='share_report'><img src={String(share)} width='15' height='15' /> Share Report</DownloadButton>}
                            {/*need to consider agg ctsa report*/}
                                {(report_type == "spending_report" || report_type.includes("CTSA-report") || report_type === "new-vendor-report2025" ||report_type==="new-vendor-report") && <DownloadButton onClick={this.handleDownloadFiles}><img src={String(download)} width='15' height='15' /> Download Data Files</DownloadButton>}
                            {(report_type == "vendor_report" || report_type == "employee_report") && <a href={this.props.UserState.downloadDataFileHref} download='report.xlsx'><img src={String(download)} width='15' height='15' /> Download Data Files</a>}
                        </span>
                        }
                        {(report_type.startsWith("new-vendor-report") || report_type == "employee_report" || report_type == "spending_report") && <DownloadButton onClick={this.handleDownloadPDF(this.state.activeTabIndex, report_type)} disabled={report_type == "spending_report" && !this.state.spendingDataAllLoaded}><img src={String(download)} width='15' height='15' /> Download Report </DownloadButton>}
                        {(this.state.downloadWasCalled) && <span style={{ color: 'white', marginLeft: '10px', fontSize: "18px" }}>downloading..</span>}
                    </div>
                    <div className='header_logo'>
                        <img src={String(irislogo)} height='100' />
                    </div>
                </div>
            </header>
            <div className='content'>
                <div className="topBackdrop"></div>
                <div className='all'>
                    {this.renderChildrenWithProps()}
                </div>
            </div>
            <footer>
                <div className='in_footer'>
                    <div className='links'>
                    {notShared &&
                    <span>
                    {(report_type != "detailed-district-report") && <DownloadButton onClick={this.handleOpenSharedLink} className='share_report'><img src={String(share)} width='15' height='15' /> Share Report</DownloadButton>}
                                {(report_type == "spending_report" || report_type.includes("CTSA-report") || report_type === "new-vendor-report2025" ||report_type==="new-vendor-report") && <DownloadButton onClick={this.handleDownloadFiles}><img src={String(download)} width='15' height='15' /> Download Data Files</DownloadButton>}
                    {(report_type == "vendor_report" || report_type == "employee_report") && <a href={this.props.UserState.downloadDataFileHref} download='report.xlsx'><img src={String(download)} width='15' height='15' /> Download Data Files</a>}
                    </span>
                        }
                        {(report_type.startsWith("new-vendor-report") || report_type == "employee_report" || report_type == "spending_report") && <DownloadButton onClick={this.handleDownloadPDF(this.state.activeTabIndex, report_type)} disabled={report_type == "spending_report" && !this.state.spendingDataAllLoaded}><img src={String(download)} width='15' height='15' /> Download Report </DownloadButton>}
                        {(this.state.downloadWasCalled) && <span style={{ color: 'white', marginLeft: '10px', fontSize: "18px" }}>downloading..</span>}
                    </div>
                    <div>
                        </div>
                    <div className="logo logo--footer">
                        <img src={String(irislogo)} height='60' />
                    </div>
                </div>
            </footer>
        </div>;
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            downloadReport: downloadReport,
            clearSharedLink: clearSharedLink,
            downloadPDFReport: downloadPDFReport,
            downloadCTSAData,
            downloadNewVendorReportData,
            downloadNewVendorReportData2025
        }, dispatch
    )
}
          
const mapStateToProps = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    SpendingReportState: state.spendingReportProperties,
    EmployeeReportState: state.employeeReportProperties,
    UserState: state.userProperties,
    CTSAReportState: state.CTSAReportProperties,
    VendorReportState: state.vendorReportProperties,
    VendorReportState2025: state.vendorReportProperties2025
});


export default connect(
    mapStateToProps,
    matchDispatchToProps)(ReportLayout);


